import React from 'react'
import { Checkbox, FormControl, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { ModalConfirmacao } from 'components'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <Checkbox checked fontSize="small" />

export const ModalAtribuirExaminador = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    carregandoCandidatos,
    examinadoresCandidatos,
    novosExaminadores,
    onChangeNovoExaminador,
  } = props

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      titulo="Atribuir Examinador"
      confirmarLabel="Atribuir usuários"
      disabled={processando || !novosExaminadores || novosExaminadores.length < 1}
      maxWidth="sm"
    >
      <FormControl style={{ minWidth: '100%', maxWidth: '100%', marginTop: '10px' }}>
        <AutocompleteNative
          value={novosExaminadores}
          multiple
          name="novosExaminadores"
          loading={carregandoCandidatos}
          loadingText="Carregando examinadores..."
          noOptionsText="Sem informações"
          options={examinadoresCandidatos || []}
          disableCloseOnSelect
          onChange={onChangeNovoExaminador}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome?.toUpperCase() || ''} - ${option.cargo ? option.cargo.nome?.toUpperCase() : ''}`}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {`${option.nome?.toUpperCase() || ''} - ${option.cargo ? option.cargo.nome?.toUpperCase() : ''}`}
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Examinadores candidatos"
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </FormControl>
    </ModalConfirmacao>
  )
}
